import {HttpAxiosRequest} from 'src/http/httpAxiosBase';

const getEndpoint = (idOperacion: number, url = '') => 
    `/operaciones/${idOperacion}/informe${url}`;

export const HttpOperacionInforme = {
    descargarInforme: (idOperacion: number, codSistema: number): Promise<any> =>
        HttpAxiosRequest.getBlob(
            getEndpoint(idOperacion, `/descargar`),
            {
                sistema: codSistema
            }),
}
